// extracted by mini-css-extract-plugin
export default {"menuIcon":"VendorMenuBar_menuIcon__NNfnk","backIcon":"VendorMenuBar_backIcon__Te8Kq","fixed":"VendorMenuBar_fixed__rApm-"};